import { TFunction } from 'i18next'
import { Color } from '@/components/GokuDataGrid/CellStatus'

// ================== Promo Status ==================

export const PROMO_STATUS_OPTIONS = (t: TFunction) => [
    {
        label: t('active'),
        value: 'active',
        color: 'success' as Color,
    },
    {
        label: t('inactive'),
        value: 'inactive',
        color: 'default' as Color,
    },
    {
        label: t('expired'),
        value: 'expired',
        color: 'error' as Color,
    },
]

// ================== Promo Type ==================

export const PROMO_TYPE_OPTIONS = (t: TFunction) => [
    {
        label: t('percentage'),
        value: 'percentage',
    },
    {
        label: t('fixed_amount'),
        value: 'fixed',
    },
]

// ================== Filter Options ==================

export const getPromoStatusFilterOptions = (t: TFunction) => [
    { label: t('active'), value: 'active' },
    { label: t('inactive'), value: 'inactive' },
    { label: t('expired'), value: 'expired' },
]

export const getPromoTypeFilterOptions = (t: TFunction) => [
    { label: t('percentage'), value: 'percentage' },
    { label: t('fixed_amount'), value: 'fixed' },
]
